import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingState } from '@payment-plan/ui';
import { useAuth } from '../auth/auth-context';

export function ProtectedRoute(): React.JSX.Element {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState message="Cargando sesión" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
